module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-18-500-normal.b13afab.woff2";